import { render, staticRenderFns } from "./StudyChallenge.vue?vue&type=template&id=5306b4c2&scoped=true&lang=pug&"
import script from "./StudyChallenge.vue?vue&type=script&lang=ts&"
export * from "./StudyChallenge.vue?vue&type=script&lang=ts&"
import style0 from "./StudyChallenge.vue?vue&type=style&index=0&id=5306b4c2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5306b4c2",
  null
  
)

export default component.exports